export interface ICongressionalRecordPDF {
  Part: string
  Url: string
}
